import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TRequestStatus } from "@/types/request-status";

export interface TRequestStatusCreateData {
  name: string;
  color: string;
  group: TRequestStatus["group"];
  description?: string | null;
}

export interface TRequestStatusUpdateData {
  name?: string;
  color?: string;
  group?: TRequestStatus["group"];
  description?: string | null;
  sequence?: number;
}

export class RequestStatusService extends ApiService {
  async list(slug: string, config?: ApiRequestConfig): Promise<TRequestStatus[]> {
    return this.get(`/api/workspaces/${slug}/request-statuses/`, config);
  }

  /**
   * The request-scoped sibling of {@link list}: the same workspace-wide list
   * (same query, same order, same serializer), but gated on `request.read`
   * instead of `state_machine.read`, so a guest whose board needs the
   * statuses can load the options even when the settings list 403s (NG-2764).
   */
  async listPickable(slug: string, config?: ApiRequestConfig): Promise<TRequestStatus[]> {
    return this.get(`/api/workspaces/${slug}/request-status-options/`, config);
  }

  async create(slug: string, data: TRequestStatusCreateData): Promise<TRequestStatus> {
    return this.post(`/api/workspaces/${slug}/request-statuses/`, data);
  }

  async update(
    slug: string,
    stateId: string,
    data: TRequestStatusUpdateData,
  ): Promise<TRequestStatus> {
    return this.patch(`/api/workspaces/${slug}/request-statuses/${stateId}/`, data);
  }

  async remove(slug: string, stateId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/request-statuses/${stateId}/`);
  }

  async markDefault(slug: string, stateId: string): Promise<TRequestStatus> {
    return this.post(`/api/workspaces/${slug}/request-statuses/${stateId}/mark-default/`, {});
  }
}
